import { Typography } from 'antd';
import DatePickerr from './DatePickerr';
import DropdownState from './DropdownState';
import DropdownFilter from './DropdownFilter';
import SearchInput from './SearchInput';

interface Dropdown {
  title: string;
  value: string;
}

interface Props {
  handleDateValue: Function;
  handleStateValue: Function;
  handleFilterValue: Function;
  handleInputValue: Function;
  stateBox: Dropdown[],
  filterBox: Dropdown[]
}

function FilterAction({
  handleDateValue,
  handleStateValue,
  handleFilterValue,
  handleInputValue,
  stateBox,
  filterBox
}: Props) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '9px',
        marginBottom: '21px'
      }}
      className="busk-filter-action"
    >
      <DatePickerr handleDateValue={handleDateValue} />
      <Typography.Text style={{ fontSize: '1rem' }}>상태</Typography.Text>

      <DropdownState
        filterBy={stateBox}
        //filter
        handleStateValue={handleStateValue}
      />

      <DropdownFilter
        searchBy={filterBox}
        //filter
        handleFilterValue={handleFilterValue}
      />
      <SearchInput handleInputValue={handleInputValue} />
    </div>
  );
}

export default FilterAction;
